import React, { useState } from "react";
import { FormattedHTMLMessage, useIntl, Link } from "gatsby-plugin-intl";
import { css } from "@emotion/core";
import { Desktop, Tablet } from "../../constants/responsive";
import Blank from "../../components/Blank";

const SelectFilter = ({ label, value, setValue, options, name }) => {
  const intl = useIntl();
  return (
    <div
      css={css`
        flex: 1;
      `}
    >
      {/* 手机端label在灰框外 */}
      <div
        css={css`
          color: #161616;
          font-size: 10px;
          font-weight: 500;
          line-height: 2;
          ${Tablet} {
            display: none;
          }
        `}
      >
        <FormattedHTMLMessage id={`career.join.${label}`} />
      </div>
      <div
        css={css`
          background-color: #f2f2f2;
          width: 325px;
          border-radius: 10px;
          height: 33px;
          padding: 0 10px 0 9px;
          ${Tablet} {
            height: auto;
            padding: 0px 13px 6px 9px;
            width: 158px;
          }
          ${Desktop} {
            border-radius: 15px;
            padding: 4px 16px 5px 15px;
            width: 213px;
          }
        `}
      >
        {/* WEB、IPAD端的label在灰框里 */}
        <div
          css={css`
            display: none;
            color: #161616;
            ${Tablet} {
              display: block;
              font-size: 10px;
              font-weight: 500;
              line-height: 1.25;
              padding: 5px 0 0 0px;
            }
            ${Desktop} {
              font-size: 12px;
              font-weight: 500;
              line-height: 2;
              padding: 0;
            }
          `}
        >
          <FormattedHTMLMessage id={`career.join.${label}`} />
        </div>
        <select
          css={css`
            // 去除浏览器select的默认样式，添加自定义按钮样式
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            background: url(/career/select-icon.png) no-repeat;
            background-size: 9px;
            background-position: right;
            width: 100%;
            border: none;
            color: #808080;
            height: 100%;
            font-size: 12px;
            font-weight: normal;
            line-height: 2.75;
            ${Tablet} {
              background-position: right;
              background-size: 9px;
              height: auto;
              font-size: 12px;
              font-weight: normal;
              line-height: normal;
            }
            ${Desktop} {
              background-position: right;
              background-size: 12px;
              font-size: 16px;
              font-weight: normal;
              line-height: 1.75;
            }
          `}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
        >
          <option value="">
            {intl.formatMessage({ id: "career.join.any" })}
            {intl.locale === "en" && " "}
            {intl.formatMessage({ id: `career.join.${label}` })}
          </option>
          {options.map((option) => {
            return (
              <option key={option} value={option}>
                {intl.formatMessage({ id: `career.job.${name}.${option}` })}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

const DepartmentTitle = ({ name = "ICG" }) => {
  const intl = useIntl();
  return (
    <div
      className={`department-${name}`}
      css={css`
        color: #000000;
        font-size: 18px;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 20px;
        ${Tablet} {
          font-size: 20px;
          font-weight: 500;
          line-height: 1.65;
          margin-bottom: 20px;
        }
        ${Desktop} {
          font-size: 24px;
          font-weight: 500;
          line-height: 1.38;
          margin-bottom: 20px;
        }
      `}
    >
      {intl.formatMessage({ id: `career.job.departments.${name}` })}
    </div>
  );
};

const JobItem = ({ job, actively = false }) => {
  const [selected, setSelected] = useState(false);
  const intl = useIntl();
  return (
    <Link
      css={css`
        width: 100%;
        height: 100%;
      `}
      to={`/about/job/${job}`}
    >
      <div
        key={job.id}
        css={css`
          :last-child {
            border-bottom: 0px;
          }

          width: 325px;
          height: 100%;
          padding: 0 25px;
          ${Tablet} {
            border-bottom: 1px solid #e6e6e6;
            width: 708px;
            height: 45px;
            padding: 0;
          }
          ${Desktop} {
            width: 1206px;
            height: ${actively ? "79px" : "73px"};

            border-bottom: 1px solid #e5e5e5;
          }
        `}
      >
        <div
          onClick={() => {
            setSelected(!selected);
          }}
          css={css`
            display: flex;

            cursor: pointer;
            position: relative;
            flex-wrap: wrap;
            padding: 10px 0;
            width: 275px;
            height: 100%;
            border-bottom: 1px solid #f2f2f2;

            ${Tablet} {
              flex-wrap: nowrap;
              width: 100%;
              height: 100%;
              padding: 10px 17px;
            }
            ${Desktop} {
              padding: ${actively ? "23px" : "20px"};
            }
          `}
        >
          {/* Job职位 */}
          <div
            css={css`
              width: 100%;
              display: flex;
              align-items: center;
              margin-bottom: 2px;
              ${Tablet} {
                margin-bottom: 0;
                width: 470px;
              }
              ${Desktop} {
                width: 816px;
              }
            `}
          >
            <h2
              css={css`
                text-align: left;
                font-size: 14px;
                font-weight: 500;
                line-height: 1.71;
                margin: 0px;
                ${Tablet} {
                  font-size: 14px;
                  font-weight: normal;
                  line-height: 1.71;
                }
                ${Desktop} {
                  font-size: ${actively ? "22px" : "18px"};
                  font-weight: normal;
                  line-height: ${actively ? "1.5" : "1.83"};
                }
              `}
            >
              {intl.formatMessage({ id: `career.job.jobsInfo.${job}.title` })}
            </h2>
            {actively && (
              <span
                css={css`
                  display: none;
                  ${Tablet} {
                    display: block;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 2.75;
                    color: #ee2f79;
                    margin-left: 20px;
                  }
                  ${Desktop} {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 2.06;
                    color: #ee2f79;
                    margin-left: 20px;
                  }
                `}
              >
                (Actively Hiring)
              </span>
            )}
          </div>
          {/* Job工作地点 */}
          <h5
            css={css`
              text-align: center;
              margin: 0px;
              font-size: 14px;
              font-weight: normal;
              line-height: 1.71;
              ${Tablet} {
                width: 150px;
                font-size: 14px;
                font-weight: normal;
                line-height: 1.71;
              }
              ${Desktop} {
                width: 190px;
                font-size: ${actively ? "22px" : "18px"};
                font-weight: normal;
                line-height: ${actively ? "1.5" : "1.83"};
              }
            `}
          >
            {intl.formatMessage({ id: `career.job.jobsInfo.${job}.location` })}
          </h5>
          {/* Job职位类型 */}
          <Blank width={[30, 0, 0]} />
          <h5
            css={css`
              text-align: center;
              margin: 0px;
              font-size: 14px;
              font-weight: normal;
              line-height: 1.71;
              ${Tablet} {
                width: 100px;
                font-size: 14px;
                font-weight: normal;
                line-height: 1.71;
              }
              ${Desktop} {
                width: 160px;
                font-size: ${actively ? "22px" : "18px"};
                font-weight: normal;
                line-height: ${actively ? "1.5" : "1.83"};
              }
            `}
          >
            {intl.formatMessage({ id: `career.job.jobsInfo.${job}.type` })}
          </h5>
          {/* 急招字样 - MOBILE */}
          {actively && (
            <span
              css={css`
                font-size: 12px;
                font-weight: 500;
                line-height: 1.99;
                color: #ee2f79;
                width: 100%;
                ${Tablet} {
                  display: none;
                }
              `}
            >
              (Actively Hiring)
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

const CareerJobList = ({ jobListRef }) => {
  const intl = useIntl();
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedPosition, setSelectedPosition] = useState("");

  const locations = ["hk", "sz"];
  const departments = ["IT", "ICG", "SO", "Algo"];
  const positions = ["full-time", "intern"];

  // 所有待招职位
  const allJobs = [
    // {
    //   title: `senior-big-data-developer`,
    //   locations: ["sz"],
    //   department: `IT`,
    //   types: ["full-time"],
    // },

    // {
    //   title: `senior-ios-software-engineer`,
    //   locations: ["sz"],
    //   department: `IT`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `cloud-solutions-architect`,
    //   locations: ["sz"],
    //   department: `IT`,
    //   types: ["full-time"],
    // },
    {
      title: `java-software-engineer`,
      locations: ["sz"],
      department: `IT`,
      types: ["full-time"],
    },
    {
      title: `frontend-software-engineer`,
      locations: ["sz"],
      department: `IT`,
      types: ["full-time"],
    },
    // {
    //   title: `asset-management`,
    //   locations: ["hk"],
    //   department: `ICG`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `institutional-sales`,
    //   locations: ["sz", "hk"],
    //   department: `ICG`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `strategic-review-consultant`,
    //   locations: ["hk"],
    //   department: `SO`,
    //   types: ["intern"],
    // },
    // {
    //   title: `settlement-assistant`,
    //   locations: ["hk"],
    //   department: `SO`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `head-of-CF&IR`,
    //   locations: ["hk"],
    //   department: `SO`,
    //   types: ["full-time"],
    // },
    {
      title: `senior-product-manager`,
      locations: ["hk"],
      department: `IT`,
      types: ["full-time"],
    },
    {
      title: `product-manager-intern-financial-ai`,
      locations: ["sz", "hk"],
      department: `IT`,
      types: ["intern"],
    },
    {
      title: `intern`,
      locations: ["hk"],
      department: `ICG`,
      types: ["intern"],
    },
    // {
    //   title: `ai-algorithm-engineer`,
    //   locations: ["sz", "hk"],
    //   department: `Algo`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `python-senior-software-engineer`,
    //   locations: ["sz", "hk"],
    //   department: `Algo`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `financial-product-manager`,
    //   locations: ["sz", "hk"],
    //   department: `Algo`,
    //   types: ["full-time", "intern"],
    // },
    {
      title: `quantitative-developer`,
      locations: ["sz", "hk"],
      department: `Algo`,
      types: ["full-time"],
    },
    // {
    //   title: `senior-devops-engineer-financial-services`,
    //   locations: ["sz", "hk"],
    //   department: `Algo`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `backend-developer`,
    //   locations: ["sz", "hk"],
    //   department: `Algo`,
    //   types: ["full-time"],
    // },
    // {
    //   title: `quantitative-developer-financial-service`,
    //   locations: ["sz", "hk"],
    //   department: `Algo`,
    //   types: ["full-time"],
    // },
    {
      title: `quantitative-researcher-fulltime`,
      locations: ["sz", "hk"],
      department: `Algo`,
      types: ["full-time"],
    },
    {
      title: `senior-quantitative-researcher`,
      locations: ["sz", "hk"],
      department: `Algo`,
      types: ["full-time"],
    },
    {
      title: `quantitative-engineer`,
      locations: ["sz", "hk"],
      department: `Algo`,
      types: ["full-time"],
    },
    {
      title: `quantitative-research-backtest-and-live-trading-platform`,
      locations: ["sz", "hk"],
      department: `Algo`,
      types: ["intern"],
    },
    {
      title: `quantitative-researcher`,
      locations: ["sz", "hk"],
      department: `Algo`,
      types: ["intern"],
    },
    {
      title: `data-product-manager-ba-intern-financial-ai`,
      locations: ["sz", "hk"],
      department: `Algo`,
      types: ["intern"],
    },
    // {
    //   title: `ai-model-researcher`,
    //   locations: ["sz", "hk"],
    //   department: `Algo`,
    //   types: ["full-time"],
    // },
  ];
  // 被筛选剩下的职位
  var filteredJobs = {
    ICG: [],
    IT: [],
    Algo: [],
    SO: [],
  };
  // 被筛选剩余职位数量
  var filteredJobsCount = 0;
  // debugger;
  allJobs
    .filter((job) => {
      return selectedPosition ? job.types.includes(selectedPosition) : true;
    })
    .filter((job) => {
      return selectedLocation ? job.locations.includes(selectedLocation) : true;
    })
    .filter((job) => {
      return selectedDepartment ? job.department === selectedDepartment : true;
    })
    .map((filteredJob) => {
      filteredJobsCount++;
      filteredJobs[filteredJob.department].push(filteredJob);
    });
  // debugger;
  return (
    <div ref={jobListRef} className="career-Job-List">
      <div
        css={css`
          display: flex;
          flex-direction: column;
          ${Tablet} {
            flex-direction: row;
          }
        `}
      >
        <div
          css={css`
            color: #000000;
            font-size: 22px;
            font-weight: 500;
            line-height: 1.5;
            ${Tablet} {
              font-size: 22px;
              font-weight: 500;
              line-height: 1.5;
            }
            ${Desktop} {
              font-size: 36px;
              font-weight: bold;
              line-height: 0.92;
            }
          `}
        >
          {intl.formatMessage({ id: `career.where-you-fit.title` })}
        </div>
        <Blank width={[0, 119, 245]} />
        <SelectFilter
          name="positions"
          label="position"
          value={selectedPosition}
          setValue={setSelectedPosition}
          options={positions}
        />
        <Blank width={[0, 10, 23]} height={[13, 0, 0]} />
        <SelectFilter
          name="locations"
          label="location"
          value={selectedLocation}
          setValue={setSelectedLocation}
          options={locations}
        />
        <Blank width={[0, 10, 23]} height={[13, 0, 0]} />
        <SelectFilter
          name="departments"
          label="department"
          value={selectedDepartment}
          setValue={setSelectedDepartment}
          options={departments}
        />
      </div>
      <h5
        css={css`
          color: #000000;
          display: block;
          margin: 20px 0;

          font-size: 14px;
          font-weight: normal;
          line-height: 1.71;
          ${Tablet} {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.71;
            margin: 8px 0 20px;
          }
          ${Desktop} {
            font-size: 22px;
            font-weight: normal;
            line-height: normal;
            margin: 2px 0 30px;
          }
        `}
      >
        <b>{filteredJobsCount}</b>
        <FormattedHTMLMessage id="career.join.jobs" />
      </h5>
      {departments.map((department) => {
        // 先遍历部门。
        // 求职者筛选完后，若该部门仍剩余满足筛选条件的岗位，则显示。
        // 否则，隐藏
        return (
          filteredJobs[department].length !== 0 && (
            <div key={`${department}`}>
              <DepartmentTitle name={department} />
              <section
                css={css`
                  border-radius: 15px;
                  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
                  background-color: #ffffff;
                  overflow: hidden;
                `}
              >
                {/* 遍历剩余满足条件岗位并显示 */}
                {filteredJobs[department].map((job) => {
                  return <JobItem job={job.title} key={job.title} />;
                })}
              </section>
              <Blank height={[50, 50, 50]} />
            </div>
          )
        );
      })}
    </div>
  );
};

export default CareerJobList;
